import { productMasterApi } from './api';

export const submitData = async (accessToken, transformedData) => {
	const res = productMasterApi.post('/SetProductStatus', transformedData, {
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${accessToken}`,
			accept: '*/*',
		},
	});
	console.log(res);
	return res;
};
